export interface VideoItem {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  releaseDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-mic-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-emotion-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '短片', slug: 'short', icon: 'ri-vidicon-line' },
  { name: '热门推荐', slug: 'hot', icon: 'ri-fire-line' },
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '狂飙',
    slug: 'the-knockout',
    category: '电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20dark%20atmospheric%20city%20night%20scene%2C%20dramatic%20lighting%2C%20two%20men%20in%20suits%20standing%20on%20rooftop%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20warm%20golden%20accents%20on%20dark%20background&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '45:00',
    views: 12850000,
    rating: 9.5,
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死搏斗故事。通过群像叙事展现扫黑除恶中的黑白较量与复杂人性。该剧以现实主义手法描绘了当代中国社会的法治进程，剧情紧凑扣人心弦，演员阵容强大，是近年来不可多得的国产精品剧集。',
    releaseDate: '2023-01-14',
    tags: ['犯罪', '剧情', '扫黑', '国产剧', '热门'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '流浪地球2',
    slug: 'the-wandering-earth-2',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=sci-fi%20movie%20poster%20style%20with%20massive%20space%20station%20and%20Earth%20in%20background%2C%20blue%20planet%20with%20glowing%20engines%2C%20epic%20cinematic%20lighting%2C%20dramatic%20space%20atmosphere%2C%20futuristic%20technology%20theme&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '173:00',
    views: 9650000,
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。本片视觉效果震撼，是中国科幻电影的里程碑之作。',
    releaseDate: '2023-01-22',
    tags: ['科幻', '灾难', '冒险', '国产', 'IMAX'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '繁花',
    slug: 'blossoms-shanghai',
    category: '电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20drama%20poster%20with%20neon%20lights%20and%20vintage%20street%20scene%2C%20warm%20golden%20tone%2C%20elegant%20woman%20in%20cheongsam%2C%20retro%20Chinese%20city%20nightlife%2C%20cinematic%20wong%20kar%20wai%20aesthetic&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '50:00',
    views: 8920000,
    rating: 9.3,
    description: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上人来人往，饭局觥筹交错，描绘出一幅时代画卷。该剧以独特的视觉美学和深刻的人物刻画，成为年度现象级作品。',
    releaseDate: '2023-12-27',
    tags: ['剧情', '爱情', '年代', '上海', '王家卫'],
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '长安三万里',
    slug: 'chang-an',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=animated%20movie%20poster%20Tang%20Dynasty%20ancient%20Chinese%20city%20Chang%20an%20with%20poets%20and%20horses%2C%20traditional%20Chinese%20painting%20style%2C%20warm%20golden%20sunset%2C%20ink%20wash%20art%20aesthetic%2C%20epic%20historical%20atmosphere&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '168:00',
    views: 7560000,
    rating: 9.0,
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。影片以动画形式展现盛唐气象，融合诗词之美与家国情怀，画面唯美震撼。',
    releaseDate: '2023-07-08',
    tags: ['动画', '历史', '诗歌', '唐代', '国风'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '封神第一部：朝歌风云',
    slug: 'creation-of-the-gods',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20beasts%2C%20dramatic%20battle%20scene%2C%20golden%20armor%2C%20epic%20cinematic%20lighting%2C%20dark%20stormy%20sky%2C%20Oriental%20fantasy%20aesthetic&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '148:00',
    views: 8230000,
    rating: 8.8,
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。史诗级神话巨制，特效精湛，演员表现出色。',
    releaseDate: '2023-07-20',
    tags: ['奇幻', '神话', '动作', '史诗', '封神'],
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: '三体',
    slug: 'three-body',
    category: '电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=sci-fi%20TV%20series%20poster%20with%20mysterious%20cosmic%20signal%20and%20three%20suns%2C%20futuristic%20laboratory%2C%20dark%20atmospheric%20sci-fi%20aesthetic%2C%20Chinese%20scientists%2C%20cosmic%20mystery%2C%20cinematic%20suspense&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '50:00',
    views: 6780000,
    rating: 8.9,
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入神秘组织"科学边界"协助调查。随着调查深入，一个关于外星文明三体人的惊天秘密逐渐浮出水面。改编自刘慈欣同名科幻巨著，忠实还原原著精髓。',
    releaseDate: '2023-01-15',
    tags: ['科幻', '悬疑', '刘慈欣', '国产', '硬科幻'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '乘风破浪的姐姐4',
    slug: 'sisters-who-make-waves-4',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20elegant%20women%20in%20stunning%20stage%20costumes%2C%20sparkling%20stage%20lights%2C%20glamorous%20performance%20scene%2C%20entertainment%20show%20vibe%2C%20bright%20warm%20stage%20lighting&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '120:00',
    views: 5420000,
    rating: 8.5,
    description: '三十位30+的姐姐们再次集结，她们打破年龄界限，在舞台上绽放自我。从练习室到公演舞台，姐姐们用汗水和努力证明：女人的美不应该被年龄定义。节目充满正能量，展现了女性之间的温暖互助和激烈竞争。',
    releaseDate: '2024-05-17',
    tags: ['综艺', '女性', '音乐', '竞技', '真人秀'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '熊出没·逆转时空',
    slug: 'boonie-bears-time-twist',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=cute%20animated%20movie%20poster%20with%20two%20cartoon%20bears%20in%20colorful%20forest%20adventure%2C%20bright%20cheerful%20tone%2C%20family%20friendly%203D%20animation%20style%2C%20magical%20time%20travel%20elements%2C%20warm%20sunlight%20forest&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '99:00',
    views: 4100000,
    rating: 8.2,
    description: '光头强是一名普通程序员，却常梦见陌生的森林和两头狗熊。直到他跟上司出访大客户，终于想起：他原是森林的小导游，偶然得到一次重新选择人生的机会。为了挽救旧时间线里的熊大熊二，光头强开始了一场奇妙的时空冒险。',
    releaseDate: '2024-02-10',
    tags: ['动画', '喜剧', '冒险', '合家欢', '贺岁'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '舌尖上的中国4',
    slug: 'a-bite-of-china-4',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20beautiful%20traditional%20Chinese%20cuisine%20closeup%2C%20steaming%20hot%20dishes%2C%20warm%20kitchen%20atmosphere%2C%20artistic%20food%20photography%2C%20rich%20colors%20and%20textures%2C%20cultural%20culinary%20heritage&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '50:00',
    views: 3890000,
    rating: 9.1,
    description: '第四季延续前作的精良制作，继续深入中国各地，探寻美食背后的人文故事。从东北的冰天雪地到海南的热带雨林，从西北的黄土高原到东南的沿海渔村，每一道美食都承载着一方水土的记忆与情感。',
    releaseDate: '2024-04-18',
    tags: ['纪录片', '美食', '文化', '人文', '国产'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '年会不能停！',
    slug: 'johnny-keep-walking',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20office%20workers%20in%20modern%20corporate%20setting%2C%20humorous%20exaggerated%20expressions%2C%20bright%20office%20lighting%2C%20corporate%20culture%20satire%2C%20colorful%20playful%20aesthetic&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '117:00',
    views: 5340000,
    rating: 8.7,
    description: '钳工胡建林阴差阳错被调入集团总部，从工厂到大楼，从蓝领变金领。他凭借朴实的工作态度和真诚的为人处世，在尔虞我诈的职场中闯出一片天地，揭露了集团内部的腐败问题。笑中带泪的职场喜剧。',
    releaseDate: '2023-12-29',
    tags: ['喜剧', '职场', '讽刺', '国产', '大鹏'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '庆余年2',
    slug: 'joy-of-life-2',
    category: '电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20palace%20and%20swordsman%2C%20dramatic%20costume%20drama%20aesthetic%2C%20mysterious%20atmosphere%2C%20martial%20arts%20theme%2C%20imperial%20Chinese%20setting%2C%20cinematic%20lighting&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '45:00',
    views: 11500000,
    rating: 9.4,
    description: '范闲从北齐归来后，在庆国朝堂之上周旋于各方势力之间。面对二皇子的步步紧逼、长公主的暗中谋划，范闲凭借过人智慧一一化解危机。第二季延续前作的高品质制作，剧情更加扣人心弦。',
    releaseDate: '2024-05-16',
    tags: ['古装', '权谋', '武侠', '穿越', '热门'],
    isHot: true,
    isNew: true,
  },
  {
    id: 12,
    title: '消失的她',
    slug: 'lost-in-the-stars',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=suspense%20thriller%20movie%20poster%20with%20tropical%20island%20resort%20and%20mysterious%20woman%2C%20dark%20atmospheric%20lighting%2C%20film%20noir%20style%2C%20psychological%20thriller%20vibe%2C%20ocean%20background%2C%20dramatic%20tension&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '121:00',
    views: 7890000,
    rating: 8.6,
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。当他苦寻无果之时，一个陌生女子突然出现，声称自己就是他的妻子。随着故事推进，层层反转，真相令人震惊。悬疑烧脑之作，反转不断。',
    releaseDate: '2023-06-22',
    tags: ['悬疑', '犯罪', '反转', '国产', '朱一龙'],
    isHot: false,
    isNew: false,
  },
  {
    id: 13,
    title: '海贼王 和之国篇',
    slug: 'one-piece-wano',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=anime%20poster%20Japanese%20samurai%20theme%20with%20pirate%20characters%20in%20traditional%20setting%2C%20action%20scene%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20shonen%20anime%20style%2C%20epic%20battle%20atmosphere&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    duration: '24:00',
    views: 4560000,
    rating: 9.3,
    description: '路飞一行人抵达和之国，与锦卫门等人会合，准备向四皇凯多发起挑战。在这片武士的国度，一场改变世界格局的大战即将爆发。和之国篇被誉为海贼王最精彩的篇章之一，战斗场面燃爆。',
    releaseDate: '2019-07-07',
    tags: ['日漫', '冒险', '热血', '战斗', '少年'],
    isHot: false,
    isNew: false,
  },
  {
    id: 14,
    title: '中国奇谭',
    slug: 'yao-chinese-folktales',
    category: '短片',
    categorySlug: 'short',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20short%20film%20poster%20with%20traditional%20ink%20painting%20style%20monster%20and%20landscape%2C%20artistic%20Chinese%20folklore%20aesthetic%2C%20mystical%20creatures%2C%20dreamlike%20atmosphere%2C%20hand-drawn%20animation%20texture&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    duration: '20:00',
    views: 3450000,
    rating: 9.0,
    description: '由八个植根于中国传统文化的独立故事组成。故事纵览古今、展望未来，从乡土眷恋到科技幻想，从生命母题到人性思考，展现了中华民族独有的想象力与文化传承。画风多元，制作精良。',
    releaseDate: '2023-01-01',
    tags: ['动画', '短片', '国风', '奇幻', '寓言'],
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    title: '我的阿勒泰',
    slug: 'to-the-wonder',
    category: '电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20with%20vast%20grassland%20and%20nomadic%20life%20in%20Xinjiang%2C%20beautiful%20natural%20landscape%2C%20warm%20sunlight%2C%20herder%20family%2C%20poetic%20pastoral%20scene%2C%20cinematic%20wide%20shot&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    duration: '45:00',
    views: 2780000,
    rating: 8.9,
    description: '生长在阿勒泰的汉族少女李文秀，一心在大城市追求文学梦想却屡屡碰壁，被迫回到老家与开小卖部的母亲相依为命。在结识哈萨克少年巴太之后，文秀渐渐发现了当地之美。治愈系田园剧，画面如诗。',
    releaseDate: '2024-05-07',
    tags: ['剧情', '田园', '治愈', '新疆', '文学改编'],
    isHot: false,
    isNew: true,
  },
  {
    id: 16,
    title: '地球脉动3',
    slug: 'planet-earth-3',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20diverse%20ecosystems%2C%20planet%20earth%20cinematography%2C%20animals%20in%20natural%20habitat%2C%20epic%20landscape%2C%20vibrant%20colors%2C%20BBC%20style%20nature%20photography&width=800&height=450&seq=video-thumb-16&orientation=landscape',
    duration: '60:00',
    views: 2340000,
    rating: 9.6,
    description: 'BBC王牌纪录片系列第三季，历时五年制作，跨越六大洲43个国家。从深海到沙漠，从极地到热带雨林，以惊人的画质展现地球上最壮丽的自然景观和最动人的动物故事。每一帧都可以做壁纸。',
    releaseDate: '2023-10-22',
    tags: ['纪录片', '自然', '动物', 'BBC', '4K'],
    isHot: false,
    isNew: false,
  },
  {
    id: 17,
    title: '与凤行',
    slug: 'the-legend-of-shen-li',
    category: '电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20costume%20drama%20poster%20with%20immortal%20beings%20in%20celestial%20palace%2C%20elegant%20ancient%20Chinese%20aesthetic%2C%20magical%20elements%2C%20romantic%20atmosphere%2C%20soft%20ethereal%20lighting%2C%20xianxia%20style&width=800&height=450&seq=video-thumb-17&orientation=landscape',
    duration: '45:00',
    views: 6230000,
    rating: 8.4,
    description: '灵界碧苍王沈璃为掌握自己的命运，在逃婚过程中受伤坠落人间，被卖参少年行云所救。二人在相处中渐生情愫，命运却再次将他们分开。仙侠巨制，赵丽颖林更新再度合作，画面唯美。',
    releaseDate: '2024-03-18',
    tags: ['仙侠', '爱情', '古装', '玄幻', '赵丽颖'],
    isHot: false,
    isNew: true,
  },
  {
    id: 18,
    title: '热辣滚烫',
    slug: 'yolo',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20boxing%20ring%20and%20female%20protagonist%2C%20inspiring%20sports%20theme%2C%20warm%20motivational%20atmosphere%2C%20gym%20setting%2C%20transformation%20story%2C%20uplifting%20cinematic%20lighting&width=800&height=450&seq=video-thumb-18&orientation=landscape',
    duration: '129:00',
    views: 10200000,
    rating: 8.3,
    description: '乐莹宅家多年，无所事事。在命运的几番捉弄下，她决定要换一种方式生活，开始了拳击训练。在与外界的接触中，她逐渐克服内心的恐惧，找到了属于自己的人生方向。贾玲导演并主演的励志喜剧。',
    releaseDate: '2024-02-10',
    tags: ['喜剧', '励志', '运动', '贾玲', '春节档'],
    isHot: false,
    isNew: false,
  },
  {
    id: 19,
    title: '奔跑吧8',
    slug: 'keep-running-8',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrity%20cast%20running%20in%20colorful%20outdoor%20setting%2C%20energetic%20fun%20atmosphere%2C%20bright%20sunny%20day%2C%20game%20show%20theme%2C%20group%20action%20shot&width=800&height=450&seq=video-thumb-19&orientation=landscape',
    duration: '100:00',
    views: 5670000,
    rating: 8.0,
    description: '新一季奔跑吧继续带来欢乐与感动。常驻MC与新加入的飞行嘉宾一起畅游祖国大好河山，在趣味游戏中挑战自我，传播正能量。节目延续了轻松愉快的风格，同时加入更多创新元素。',
    releaseDate: '2024-04-26',
    tags: ['综艺', '户外', '游戏', '真人秀', '搞笑'],
    isHot: false,
    isNew: false,
  },
  {
    id: 20,
    title: '孤注一掷',
    slug: 'no-more-bets',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20gambling%20den%20and%20intense%20faces%2C%20gritty%20realistic%20style%2C%20neon%20lights%20in%20underground%20setting%2C%20suspenseful%20atmosphere%2C%20social%20commentary%20theme&width=800&height=450&seq=video-thumb-20&orientation=landscape',
    duration: '130:00',
    views: 9450000,
    rating: 8.5,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现。揭露境外网络诈骗全产业链的现实主义力作。',
    releaseDate: '2023-08-08',
    tags: ['犯罪', '剧情', '社会', '反诈', '现实主义'],
    isHot: false,
    isNew: false,
  },
];

export const aboutPageData = {
  brandName: '桃花视频',
  foundedYear: '2018',
  slogan: '桃花盛开处，精彩永不断',
  intro: '桃花视频成立于2018年，是国内领先的在线视频流媒体平台之一。我们致力于为用户提供海量优质影视内容，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型。平台采用先进的视频编码和CDN加速技术，确保用户在任何网络环境下都能获得流畅清晰的观影体验。',
  mission: '让每一个人都能随时随地享受高品质的影视内容，用影像连接世界，传递温暖与力量。',
  vision: '成为中国最受用户喜爱的视频平台，以技术创新驱动内容分发，以用户需求为导向持续优化体验。',
  stats: [
    { label: '累计用户', value: '5000万+', icon: 'ri-user-heart-line' },
    { label: '影视资源', value: '10万+', icon: 'ri-film-line' },
    { label: '日均播放', value: '3000万+', icon: 'ri-play-circle-line' },
    { label: '合作版权方', value: '500+', icon: 'ri-team-line' },
  ],
  milestones: [
    { year: '2018', title: '平台成立', desc: '桃花视频正式上线，专注于电影和电视剧内容分发' },
    { year: '2019', title: '用户破千万', desc: '注册用户突破1000万，日活跃用户超100万' },
    { year: '2020', title: '内容扩展', desc: '新增综艺、动漫、纪录片频道，内容库突破5万部' },
    { year: '2021', title: '技术升级', desc: '全面升级视频编码技术，支持4K超高清播放' },
    { year: '2022', title: '用户破5000万', desc: '累计注册用户突破5000万，月活跃用户超2000万' },
    { year: '2023', title: 'AI智能推荐', desc: '上线AI智能推荐系统，个性化推荐更懂你的喜好' },
    { year: '2024', title: '全球化布局', desc: '开启海外市场拓展，支持多语言字幕和界面' },
  ],
  contact: {
    email: 'contact@taohuavideo.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园桃花大厦18层',
    wechat: '桃花视频',
    weibo: '@桃花视频官方',
  },
};

export const faqData = [
  {
    question: '桃花视频需要付费吗？',
    answer: '桃花视频大部分内容完全免费观看。我们也有少量的会员专属内容，会员可以享受无广告、超高清画质和优先观看新内容的特权。普通用户观看免费内容时会看到少量广告。',
  },
  {
    question: '如何注册桃花视频账号？',
    answer: '您可以通过手机号码、微信或QQ账号快速注册。在桃花视频首页点击右上角"登录/注册"按钮，选择您偏好的注册方式，按照提示完成验证即可，整个过程只需30秒。',
  },
  {
    question: '为什么有些视频无法播放？',
    answer: '可能是由于以下原因：1）您的网络连接不稳定，请检查网络后重试；2）该视频因版权原因在您所在地区暂时不可用；3）视频正在转码处理中，请稍后再试。如持续无法播放，请联系客服。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '桃花视频支持所有主流设备，包括：电脑浏览器（Chrome、Edge、Safari等）、Android手机和平板、iPhone和iPad、智能电视（小米电视、海信等品牌）。您可以在应用商店下载桃花视频App获得更好的移动端体验。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过以下方式联系我们：1）在线客服：点击网站右下角的客服图标；2）邮箱：contact@taohuavideo.com；3）客服电话：400-888-6666（工作日9:00-21:00）；4）微信公众号：搜索"桃花视频"关注后留言。',
  },
];